import { toast } from "react-toastify"

const allowedImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];

export const ERRORS = {
    INVALID_EMAIL: "Please enter a valid email.",
    REQUIRED_FIELD: "Please fill all fields.",
    UNMATCHED_STRING: "Both passwords do not match.",
    INVALID_OTP: "Please enter a 4-digits valid otp."
}

export const isEmail = (email) => {

    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    let result = regex.test(email)

    if (!result) {
        toast.error(ERRORS.INVALID_EMAIL)
    }

    return result

}

export const compareString = (first, second) => {

    let matched = first === second

    if (!matched) {
        toast.error(ERRORS.UNMATCHED_STRING)
    }

    return matched

}

export const objectValidator = (object, message) => {

    if (object && Object.entries(object).length > 0) {

        let array = Object.entries(object).map(item => {
            if (!item[1] || item[1] === null || item[1] === undefined) {
                return false
            } else {
                return true
            }
        })

        let isNull = array.includes(false)

        if (isNull) {
            toast.error(message || ERRORS.REQUIRED_FIELD)
        }

        return !isNull

    }

    toast.error(message || ERRORS.REQUIRED_FIELD)
    return false

}

export const dateFormatter = (value) => {

    if (value) {

        let date = new Date(value);

        let day = date.getDate();
        let month = date.getMonth();
        let year = date.getFullYear();

        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        if (day < 10) {
            day = '0' + day;
        }

        date = `${monthNames[month]} ${day}, ${year}`;

        return date;
    }

    return "-"

}

export const queryParams = (data) => {

    let queryStrings = Object.entries(data).map(([key, value]) => {
        if (value) {
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        }
        return ''
    })

    queryStrings = queryStrings.filter(item => item !== '')
    queryStrings = queryStrings?.length ? queryStrings.join("&") : ""

    return `?${queryStrings}`

}

export const getFileType = (filePath) => {
    return filePath.split('.').pop().toLowerCase();
};

export const isImage = (filePath) => {
    const extension = getFileType(filePath)
    return allowedImageExtensions.includes(extension);
};

export const openFileInNewTab = (fileUrl) => {
    window.open(`${process.env.REACT_APP_IMAGE_ENDPOINT}${fileUrl}`, '_blank');
};